import { Outlet } from "@tanstack/react-router"
import { ButtonLink } from "design-system/atoms/Button"
import { BadgePingText } from "design-system/molecules/BadgePingText"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { Pencil } from "lucide-react"
import { useSalesForceIntegrationQuery } from "modules/settings/hooks/salesForce/useSalesForceIntegrationQuery"
import { useTranslation } from "react-i18next"
import { AvailableModels } from "./AvailableModels"

export const SalesForceConfiguration = () => {
  const { t } = useTranslation()
  const { data } = useSalesForceIntegrationQuery()
  const hasConfiguration = data?.clientId

  return (
    <>
      <div className="flex flex-col gap-8">
        <Card>
          <CardHeader className="flex flex-row gap-4 p-4">
            <div className="grow flex flex-col gap-1">
              <CardTitle>{t("settings.integrations.salesForce.integrationCard.title")}</CardTitle>
              <CardDescription>
                {hasConfiguration
                  ? t("settings.integrations.salesForce.integrationCard.descriptionDone")
                  : t("settings.integrations.salesForce.integrationCard.descriptionPending")}
              </CardDescription>
            </div>
            <div className="flex items-center">
              {hasConfiguration ? (
                <div className="flex gap-2">
                  <BadgePingText
                    color={"success"}
                    text={t("settings.integrations.salesForce.integrationCard.connected")}
                  />
                  <ButtonLink
                    variant={"ghost"}
                    size="icon"
                    to="/settings/integrations/salesForce/connect"
                  >
                    <Pencil />
                  </ButtonLink>
                </div>
              ) : (
                <ButtonLink to={"/settings/integrations/salesForce/connect"}>
                  {t("settings.integrations.salesForce.integrationCard.configButton")}
                </ButtonLink>
              )}
            </div>
          </CardHeader>
        </Card>
        {hasConfiguration && <AvailableModels />}
      </div>
      <Outlet />
    </>
  )
}
